import React from 'react';

import asReduxFormField from '../../../components/FormElements/asReduxFormField';
import CommonQuantityPicker from '../../../components/QuantityPicker';
import { QuantityPickerWrapper, QuantityPickerLabel } from './QuantityPicker.styles';

export const QuantityPicker = asReduxFormField((props) => (
  <QuantityPickerWrapper>
    <QuantityPickerLabel>{props.placeholder}</QuantityPickerLabel>
    <CommonQuantityPicker {...props} input={{ value: props.value, onChange: props.onChange }} />
  </QuantityPickerWrapper>
));
